export default __webpack_public_path__ + "static/media/05AW4AUG66.6f00b103.jpg";